import { z } from "zod";

export const clientSchema = z.object({
	id: z.string().optional().nullable(),
	name: z.string().min(1, "Client name is required"),
	email: z.string().optional().nullable(),
	phone: z.string().optional().nullable(),
	address: z.string().optional().nullable(),
	company: z.string().optional().nullable(),
	website: z.string().optional().nullable(),
	notes: z.string().optional().nullable(),
	status: z.enum(["active", "inactive"]).default("active"),
	is_active: z.boolean().optional(),
	projects_count: z.number().optional(),
	sales_contracts_count: z.number().optional(),
	created_at: z.string().optional().nullable(),
	updated_at: z.string().optional().nullable(),
	deleted_at: z.string().optional().nullable(),
});

export type Client = z.infer<typeof clientSchema>;

export const createClientSchema = clientSchema.omit({
	id: true,
	is_active: true,
	projects_count: true,
	sales_contracts_count: true,
	created_at: true,
	updated_at: true,
	deleted_at: true,
});

export type CreateClientData = z.infer<typeof createClientSchema>;

export const updateClientSchema = createClientSchema.partial().extend({
	id: z.string(),
});

export type UpdateClientData = z.infer<typeof updateClientSchema>;

// For search/dropdown results
export const clientOptionSchema = z.object({
	id: z.string(),
	name: z.string(),
	company: z.string().nullable(),
	email: z.string().nullable(),
	display_name: z.string(),
});

export type ClientOption = z.infer<typeof clientOptionSchema>;
